<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR LOCAL DE LOTAÇÃO' : 'NOVO LOCAL DE LOTAÇÃO'" titleIcon="fas fa-map-marker-alt">
            <el-form ref="dados" :model="dados" label-position="top" @submit.native.prevent="salvar">

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="14">
                        <el-form-item label="Nome do local" prop="nome" :rules="$requiredBlur">
                            <el-input v-model="dados.nome" placeholder="Ex.: SMED — Setor Pedagógico"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="10">
                        <el-form-item label="Tipo" prop="tipo" :rules="$requiredChange">
                            <el-select v-model="dados.tipo" style="width: 100%;" @change="tipoMudou">
                                <el-option v-for="t in tipos" :key="t" :value="t" :label="rotulo(t)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-form-item v-if="dados.tipo === 'escola'" label="Escola correspondente"
                    prop="instituicao_id" :rules="$requiredChange">
                    <el-select v-model="dados.instituicao_id" filterable style="width: 100%;">
                        <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                    </el-select>
                    <small>Um local do tipo escola aponta para a unidade já cadastrada — o nome não é redigitado.</small>
                </el-form-item>

                <el-form-item label="Endereço">
                    <el-input v-model="dados.endereco"></el-input>
                </el-form-item>

                <el-form-item label="Situação">
                    <el-switch v-model="dados.situacao" active-text="Ativo" inactive-text="Inativo"></el-switch>
                </el-form-item>

                <div class="u-text-right u-mt-20">
                    <router-link to="/admin/lotacao-fisica"><el-button>CANCELAR</el-button></router-link>
                    <el-button class="u-ml-10" v-if="podeEscrever" type="primary" native-type="submit">SALVAR</el-button>
                </div>
            </el-form>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO G — item 27. */
export default {
    data: () => ({
        tipos: ['escola', 'secretaria', 'setor', 'externo'], instituicoes: [],
        dados: { nome: '', tipo: 'escola', instituicao_id: null, endereco: '', situacao: true }
    }),
    computed: {
        podeEscrever () { return [4, 5, 6, 7].includes(parseInt(this.$store.state.user.tipo)) },
        modoEdicao () { return !!this.$route.params.id }
    },
    mounted () {
        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/local-lotacao/initForm`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.instituicoes = (r.data && r.data.instituicoes) ? r.data.instituicoes : [] })
         .catch(e => this.$store.commit('throwException', e))

        if (this.modoEdicao) {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/local-lotacao/getById/${this.$route.params.id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const reg = r.data || {}
                if (reg.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(reg.erro), type: 'warning' })
                    this.$router.push('/admin/lotacao-fisica')
                    return
                }
                Object.keys(this.dados).forEach(k => { if (reg[k] !== undefined && reg[k] !== null) this.dados[k] = reg[k] })
            }).catch(e => this.$store.commit('throwException', e))
        }
    },
    methods: {
        rotulo (t) {
            return { escola: 'Escola', secretaria: 'Secretaria', setor: 'Setor', externo: 'Órgão externo' }[t] || t
        },
        /** Sair do tipo escola não deixa a instituição pendurada de uma escolha anterior. */
        tipoMudou () { if (this.dados.tipo !== 'escola') this.dados.instituicao_id = null },
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) { window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' }); return }
                window.eventBus.$emit('loading', true)
                const url = this.modoEdicao
                    ? `${this.$store.state.config.baseUrlApi}/api/local-lotacao/update/${this.$route.params.id}`
                    : `${this.$store.state.config.baseUrlApi}/api/local-lotacao/store`
                this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Local salvo.', type: 'success' })
                    this.$router.push('/admin/lotacao-fisica')
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
